const common = {
  nav: {
    listings:      "Объявления",
    international: "International",
    blog:          "Блог",
    about:         "О нас",
    contact:       "Контакты",
    cta:           "Связаться",
  },
  badge: {
    rent: "Аренда",
    sale: "Продажа",
  },
  btn: {
    whatsapp:    "Написать в WhatsApp",
    telegram:    "Telegram",
    viewProp:    "Смотреть →",
    browseList:  "Смотреть объявления",
    contactAgent:"Связаться с агентом",
    sendMsg:     "Отправить сообщение",
  },
  footer: {
    tagline:      "Ваш надёжный партнёр в сфере премиальной недвижимости Дубая и ОАЭ.",
    nav:          "Навигация",
    properties:   "Недвижимость",
    contact:      "Контакты",
    forSale:      "Продажа",
    forRent:      "Аренда",
    uae:          "ОАЭ",
    international:"International",
  },
  notFound: "Объект не найден",
};

export default common;
